<template>
  <div class="text-base flex items-center justify-between border-black border-b fixed top-0 left-0 right-0 px-4 md:px-6 py-2 bg-white z-10">
    <Search v-show="showSearch" :show="showSearch" @hide="showSearch = false" />
    <ul v-if="lang === 'en'" class="hidden md:block">
      <li class="inline mr-5"><router-link class="no-underline" to="/home"><BaseHash class="inline-hash" />2</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/about">About</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/artists">Artists</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/calendar">Calendar</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/visit">Visit</router-link></li>
      <li class="inline mr-5"><a @click="showSearch = !showSearch" class="hover-underline" href="#search">Search</a></li>
    </ul>
    <ul v-else class="hidden md:block">
      <li class="inline mr-5"><router-link class="no-underline" to="/home"><BaseHash class="inline-hash" />2</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/about">À propos</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/artists">Artistes</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/calendar">Agenda</router-link></li>
      <li class="inline mr-5"><router-link class="hover-underline" to="/visit">Info pratiques</router-link></li>
      <li class="inline mr-5"><a @click="showSearch = !showSearch" class="hover-underline" href="#search">Rechercher</a></li>
    </ul>
    <ul class="items-center hidden md:flex">
      <li @click="setLang('en')" class="selector cursor-pointer" :class="{selected: lang === 'en'}">EN</li>
      <li @click="setLang('fr')" class="selector cursor-pointer" :class="{selected: lang === 'fr'}">FR</li>
    </ul>
    <span class="md:hidden" @click="showMenu = !showMenu">
      <BaseCircleDashed v-if="!showMenu" class="h-6" />
      <BaseCircle v-else class="h-6" />
    </span>
    <span class="flex items-center md:hidden capitalize">
      <router-link class="no-underline" :to="{ name: this.$route.name }">{{ currentPage }}</router-link>
      <BaseArrowRight v-if="slug" class="h-5 mx-2 inline" />
      <span v-if="slug" class="truncate inline-block">{{ slug }}</span>
    </span>

    <ul v-if="showMenu && lang === 'en'" class="mobile-menu absolute left-0 top-0 p-4 bg-white border-black border-b w-full">
      <li><router-link class="no-underline" to="/home">Home</router-link></li>
      <li><router-link class="no-underline" to="/about">About</router-link></li>
      <li><router-link class="no-underline" to="/artists">Artists</router-link></li>
      <li><router-link class="no-underline" to="/calendar">Calendar</router-link></li>
      <li><router-link class="no-underline" to="/visit">Visit</router-link></li>
      <li class="absolute top-0 right-0 mt-4 mr-4">
        <ul class="items-center flex">
          <li @click="setLang('en')" class="selector cursor-pointer" :class="{selected: lang === 'en'}">EN</li>
          <li @click="setLang('fr')" class="selector cursor-pointer" :class="{selected: lang === 'fr'}">FR</li>
        </ul>
      </li>
    </ul>
    <ul v-else-if="showMenu && lang === 'fr'" class="mobile-menu absolute left-0 top-0 p-4 bg-white border-black border-b w-full">
      <li><router-link class="no-underline" to="/home">Home</router-link></li>
      <li><router-link class="no-underline" to="/about">À propos</router-link></li>
      <li><router-link class="no-underline" to="/artists">Artistes</router-link></li>
      <li><router-link class="no-underline" to="/calendar">Agenda</router-link></li>
      <li><router-link class="no-underline" to="/visit">Info pratiques</router-link></li>
      <li class="absolute top-0 right-0 mt-4 mr-4">
        <ul class="items-center flex">
          <li @click="setLang('en')" class="selector cursor-pointer" :class="{selected: lang === 'en'}">EN</li>
          <li @click="setLang('fr')" class="selector cursor-pointer" :class="{selected: lang === 'fr'}">FR</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Search from '@/components/Search'
export default {

  name: 'BaseNav',

  data () {
    return {
      showMenu: false,
      showSearch: false
    }
  },

  components: { Search },

  computed: {
    ...mapState([ 'lang' ]),
    currentPage () {
      if (this.lang === 'en') {
        return this.$route.name
      } else {
        return this.$route.meta.name_fr
      }
    },
    slug () {
      if (this.$route.params.slug) {
        return this.$route.params.slug.replace(/-/g, ' ')
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapActions([
      'setLang'
    ])
  },

  watch: {
    'lang' () {
      this.showMenu = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .selector
    @apply border w-12 h-12 rounded-full flex items-center justify-center border-white
  .selected
    @apply border w-12 h-12 rounded-full flex items-center justify-center border-black border-dashed
    
  .truncate
    max-width: 35vw
    
  .mobile-menu
    top: 53px
    
  a:not(.no-underline)
    &.router-link-active, &.hover-underline:hover
      border-bottom: 1px solid black

    &.router-link-exact-active
      color: black
</style>
